/* eslint-disable */

import React from 'react';
import { graphql } from 'gatsby';
import { Helmet } from 'react-helmet';
import PropTypes from 'prop-types';

import { MainLayout } from '../layouts';

import { SliceZone } from '../components';

export const query = graphql`
  query AboutoverviewQuery($uid: String!) {
    prismic {
      aboutoverview(lang: "en-us", uid: $uid) {
        _meta {
          lang
          lastPublicationDate
          type
          uid
        }
        body {
        ... on PRISMIC_AboutoverviewBodyStatistics {
          type
            label
            fields {
              stat_detail
              stat_title
            }
            primary {
              background_color
              background_image
              heading
              heading_color
              stat_detail_color
              stat_title_color
              subheading_color
              subheading
              text_color
            }
        },
        ... on PRISMIC_AboutoverviewBodyContentblock {
          type
            label
            primary {
              target_name
              background_color
              background_image
              content
              content_text_alignment
              heading
              heading_color
              image
              subheading
              subheading_color
              text_color
              wistia_id
            }
        },
        ... on PRISMIC_AboutoverviewBodyCardsv2 {
          type
            label
            fields {
              image
              link {
                ... on PRISMIC__ExternalLink {
                  _linkType
                  url
                }
              }
              text
              text_color
              title1
              title_color
            }
            primary {
              background_color
              columns
              content_alignment
              cta_button_text
              cta_button_url {
                ... on PRISMIC__ExternalLink {
                  _linkType
                  url
                }
              }
              heading
              heading_color
              subheading
              subheading_color
              text_color
              background_image
            }
        },
        ... on PRISMIC_AboutoverviewBodyTabbedcontent {
          type
            label
            primary {
              background_color
              text_color
              heading
              heading_color
              subheading
              subheading_color
              background_image
            }
            fields {
              content1
              content2
              content3
              content4
              tab_label
              label_color
              content_color
            }
        },
        ... on PRISMIC_AboutoverviewBodyCtacollage {
          type
            label
            primary {
              background_color
              background_image
              bottom_right_image
              cta_background_color
              cta_button_link {
                ... on PRISMIC__ExternalLink {
                  _linkType
                  url
                }
              }
              cta_button_text
              cta_heading
              cta_heading_color
              cta_subheading
              cta_subheading_color
              heading
              heading_color
              large_top_image
              subheading
              text_color
              subheading_color
              top_left_image
            }
        },
        ... on PRISMIC_AboutoverviewBodyOfficesmapgrid {
          type
            label
            primary {
              background_color
              background_image
              heading
              heading_color
              subheading
              subheading_color
              text_color
              google_api_key
            }
            fields {
              location_address
              location_image
              location_map_image
              location_latitude
              location_longitude
              location_name
            }
        }}
        date
        description
        path
        title
        open_graph_image
      }
    }
  }
`;

const Aboutoverview = ({ data, location }) =>
  data.prismic.aboutoverview ? (
    <MainLayout location={location} layout='aboutoverview'>
    <Helmet>
      <title>{(data.prismic.aboutoverview.title[0] && data.prismic.aboutoverview.title[0].text) || 'DigitalOcean'}</title>
      <link rel="canonical" href={data.prismic.aboutoverview.path  == '/' ? 'https://www.digitalocean.com' + data.prismic.aboutoverview.path : 'https://www.digitalocean.com' + data.prismic.aboutoverview.path + '/'} />
      <meta
        name="description"
        content={
          data.prismic.aboutoverview.description ||
          'Helping millions of developers easily build, test, manage, and scale applications of any size – faster than ever before.'
        }
      />
      <meta name="twitter:card" content="summary"/>
      <meta name="twitter:title" content={data.prismic.aboutoverview.title[0] ? data.prismic.aboutoverview.title[0].text : 'DigitalOcean'} />
      <meta name="twitter:description" content={data.prismic.aboutoverview.description ? data.prismic.aboutoverview.description : 'DigitalOcean'} />
      <meta name="twitter:image" property={data.prismic.aboutoverview.open_graph_image ? data.prismic.aboutoverview.open_graph_image.url : 'https://images.prismic.io/www-static/0026a57b93abe5b04413765253903472dab58e11_general-droplets_blog-v4_twitter---facebook.png?auto=compress,format'} />
      <meta property="og:type" content="website" />
      <meta property="og:description" content={data.prismic.aboutoverview.description ? data.prismic.aboutoverview.description : 'DigitalOcean'} />
      <meta property="og:title" content={data.prismic.aboutoverview.title[0] ? data.prismic.aboutoverview.title[0].text : 'DigitalOcean'} />
      <meta property="og:url" content={data.prismic.aboutoverview.path  == '/' ? 'https://www.digitalocean.com' + data.prismic.aboutoverview.path : 'https://www.digitalocean.com' + data.prismic.aboutoverview.path + '/'} />
      <meta property="og:image:width" content="1200" />
      <meta property="og:image:height" content="600" />
      <meta property="og:image" content={data.prismic.aboutoverview.open_graph_image ? data.prismic.aboutoverview.open_graph_image.url : 'https://images.prismic.io/www-static/0026a57b93abe5b04413765253903472dab58e11_general-droplets_blog-v4_twitter---facebook.png?auto=compress,format'} />
    </Helmet>
      <SliceZone allSlices={data.prismic.aboutoverview.body} />
    </MainLayout>
  ) : null;

Aboutoverview.propTypes = {
  data: PropTypes.object.isRequired,
};

export default Aboutoverview;
